<template>
    <div>
        <ConfigurationSummary :configuration="injectedConfig" class="account__container py-none" />

        <template v-for="(system, index) in $v.injectedConfig.$each.$iter">
            <System v-if="system.$model.inverter.details.inverterType == 'micro'" :key="index" v-slot="{ startMppt, mpptsPerDiagram }" :index="index" :system="system" :full-width="true">
                <SystemDiagramMicro
                    :system="system"
                    :start-mppt="startMppt"
                    :mppts-per-diagram="mpptsPerDiagram"
                    :full-width="true"
                    :calc-mode="true"
                >
                    <template v-slot="{ activeMppt, inverter }">
                        <div :key="activeMppt.$model.id" class="account__container py-none text--white">
                            <div class="cols">
                                <div>
                                    <h6 class="h6">Inverter</h6>
                                    <p class="small"><strong>Manufacturer:</strong> {{ inverter.manufacturer }}</p>
                                    <p class="small"><strong>Model:</strong> {{ inverter.model }}</p>
                                    <p class="small"><strong>Type:</strong> {{ inverter.type | title }}</p>
                                    <p class="small"><strong>Inverters in system:</strong> {{ activeMppt.$model.parallel }}</p>
                                </div>

                                <div>
                                    <h6 class="h6">Panel</h6>
                                    <p class="small"><strong>Manufacturer:</strong> {{ activeMppt.$model.panel.manufacturer }}</p>
                                    <p class="small"><strong>Model:</strong> {{ activeMppt.$model.panel.model }}</p>
                                    <p class="small"><strong>Panels per inverter:</strong> {{ activeMppt.$model.series }}</p>
                                </div>
                            </div>
                        </div>
                    </template>
                </SystemDiagramMicro>
            </System>

            <System v-else :key="index" v-slot="{ startMppt, mpptsPerDiagram, flags }" :index="index" :system="system" :full-width="true">
                <SystemDiagramString
                    :system="system"
                    :temperature="job.details.temperature"
                    :building-type="job.details.buildingType"
                    :start-mppt="startMppt"
                    :mppts-per-diagram="mpptsPerDiagram"
                    :full-width="true"
                    :calc-mode="true"
                    :flags="flags"
                >
                    <template v-slot="{ activeMppt, inverter }">
                        <div :key="activeMppt.$model.id" class="account__container py-none text--white">
                            <div class="cols">
                                <div>
                                    <h6 class="h6">Inverter</h6>
                                    <p class="small"><strong>Manufacturer:</strong> {{ inverter.manufacturer }}</p>
                                    <p class="small"><strong>Model:</strong> {{ inverter.model }}</p>
                                    <p class="small"><strong>Type:</strong> {{ inverter.type | title }}</p>
                                </div>

                                <div>
                                    <h6 class="h6">MPPT {{ activeMppt.$model.id }}</h6>
                                    <p class="small"><strong>Panel manufacturer:</strong> {{ activeMppt.$model.panel.manufacturer }}</p>
                                    <p class="small"><strong>Panel model:</strong> {{ activeMppt.$model.panel.model }}</p>
                                    <p class="small"><strong>Panels in series</strong> {{ activeMppt.$model.series }}</p>
                                    <p class="small"><strong>Strings in parallel</strong> {{ activeMppt.$model.parallel }}</p>
                                    <p class="small"><strong>Total DCUs</strong> {{ activeMppt.$model.dcus }}</p>
                                </div>
                            </div>
                        </div>
                    </template>
                </SystemDiagramString>
            </System>
        </template>
    </div>
</template>

<script>
import { map, get, startCase } from 'lodash';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import System from "@/jobs/new/System";
import ConfigurationSummary from "@/jobs/new/ConfigurationSummary";
import SystemDiagramString from "@/jobs/new/SystemDiagramString";
import SystemDiagramMicro from "@/jobs/new/SystemDiagramMicro";
import { MPPT_TEMPLATE } from '@/jobs/store/configuration';

export default {
    components: {
        System,
        SystemDiagramString,
        SystemDiagramMicro,
        ConfigurationSummary,
    },

    filters: {
        title(val) {
            return startCase(val);
        }
    },

    mixins: [validationMixin],

    data() {
        return {
            job: JSON.parse(this.$root.job),
            products: JSON.parse(this.$root.products),
            configuration: JSON.parse(this.$root.configuration),
        };
    },

    computed: {
        // Basic config injected with data from product lookup data
        injectedConfig() {
            return map(this.configuration, (system) => {
                const inverter = this.products.inverters.inverters.find((i) => i.id == system.id);
                const mpptMax = Number(get(inverter, 'details.numberOfMPPTrackers', 1));
                const mppts = Array(mpptMax).fill().map((i, index) => {
                    const foundMppt = system.mppts.find((mppt) => mppt.id == index + 1);
                    return foundMppt ? {
                        ...foundMppt,
                        panel: this.products.pvModules.panels.find((prod) => prod.id == foundMppt.panel.id),
                    } : MPPT_TEMPLATE(index);
                });

                return {
                    ...system,
                    inverter,
                    mppts
                };
            });
        },
    },

    // As the diagram components are built assuming validation is always present,
    // a dummy validation object is needed so variable structure is consistent (system.$model.id)
    validations: {
        injectedConfig: {
            $each: {
                inverter: {
                    required
                },
                mppts: {
                    $each: {
                        required
                    }
                }
            }
        }
    },
};
</script>

<style lang="scss" scoped>
    .cols {
        display: flex;
        flex-wrap: wrap;

        > div {
            width: 48%;
            margin-bottom: 25px;

            @media screen and (max-width: 799px) {
                width: 100%;
            }
        }

        .h6 {
            margin-bottom: 0.5em;
        }
    }
</style>
